import React, { useState, useEffect } from 'react';
import { getMySubjects, getSubjectStudents, uploadMarks, getMarks } from '../../api';
import { toast } from 'react-toastify';

const UploadMarks = () => {
  const [subjects, setSubjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [marks, setMarks] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [formData, setFormData] = useState({
    student_id: '', exam_type: 'quiz',
    obtained_marks: '', total_marks: '', remarks: ''
  });

  useEffect(() => { loadSubjects(); }, []);

  const loadSubjects = async () => {
    try {
      const res = await getMySubjects();
      setSubjects(res.data);
    } catch (err) {
      toast.error('Error loading subjects');
    }
  };

  const loadStudentsAndMarks = async (subjectId) => {
    try {
      const [s, m] = await Promise.all([
        getSubjectStudents(subjectId),
        getMarks(subjectId)
      ]);
      setStudents(s.data);
      setMarks(m.data);
    } catch (err) {
      toast.error('Error loading data');
    }
  };

  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
    if (e.target.value) loadStudentsAndMarks(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await uploadMarks({ ...formData, subject_id: selectedSubject });
      toast.success('Marks uploaded!');
      setFormData({ student_id: '', exam_type: 'quiz', obtained_marks: '', total_marks: '', remarks: '' });
      loadStudentsAndMarks(selectedSubject);
    } catch (err) {
      toast.error('Error uploading marks');
    }
  };

  return (
    <div>
      <h3 style={styles.title}>📊 Upload Marks</h3>

      <div style={styles.card}>
        <label style={styles.label}>Select Subject</label>
        <select style={styles.input} value={selectedSubject}
          onChange={handleSubjectChange}>
          <option value="">-- Select Subject --</option>
          {subjects.map(s => (
            <option key={s.id} value={s.id}>{s.name} - {s.class_name}</option>
          ))}
        </select>
      </div>

      {selectedSubject && (
        <div style={styles.card}>
          <h4 style={styles.formTitle}>Add Marks</h4>
          <form onSubmit={handleSubmit}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Student</label>
                <select style={styles.input} value={formData.student_id}
                  onChange={e => setFormData({...formData, student_id: e.target.value})} required>
                  <option value="">Select Student</option>
                  {students.map(s => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Exam Type</label>
                <select style={styles.input} value={formData.exam_type}
                  onChange={e => setFormData({...formData, exam_type: e.target.value})}>
                  <option value="quiz">Quiz</option>
                  <option value="assignment">Assignment</option>
                  <option value="midterm">Midterm</option>
                  <option value="final">Final</option>
                  <option value="practical">Practical</option>
                </select>
              </div>
              <div>
                <label style={styles.label}>Obtained Marks</label>
                <input style={styles.input} type="number" placeholder="e.g. 18"
                  value={formData.obtained_marks}
                  onChange={e => setFormData({...formData, obtained_marks: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Total Marks</label>
                <input style={styles.input} type="number" placeholder="e.g. 20"
                  value={formData.total_marks}
                  onChange={e => setFormData({...formData, total_marks: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Remarks</label>
                <input style={styles.input} placeholder="Optional remarks"
                  value={formData.remarks}
                  onChange={e => setFormData({...formData, remarks: e.target.value})} />
              </div>
            </div>
            <button type="submit" style={styles.submitBtn}>Upload Marks</button>
          </form>
        </div>
      )}

      {marks.length > 0 && (
        <div style={styles.tableCard}>
          <h4 style={styles.formTitle}>Uploaded Marks</h4>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tableHeader}>
                <th style={styles.th}>Student</th>
                <th style={styles.th}>Exam Type</th>
                <th style={styles.th}>Obtained</th>
                <th style={styles.th}>Total</th>
                <th style={styles.th}>Percentage</th>
                <th style={styles.th}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {marks.map(m => (
                <tr key={m.id} style={styles.tableRow}>
                  <td style={styles.td}>{m.student_name}</td>
                  <td style={styles.td}>
                    <span style={styles.badge}>{m.exam_type}</span>
                  </td>
                  <td style={styles.td}>{m.obtained_marks}</td>
                  <td style={styles.td}>{m.total_marks}</td>
                  <td style={styles.td}>
                    {((m.obtained_marks/m.total_marks)*100).toFixed(1)}%
                  </td>
                  <td style={styles.td}>{m.remarks || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const styles = {
  title: { color: '#1a6b3a', marginBottom: '20px' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a6b3a', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px', marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  submitBtn: { padding: '10px 25px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tableCard: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a6b3a' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
  badge: { padding: '3px 10px', background: '#e8f5e9', color: '#1a6b3a', borderRadius: '20px', fontSize: '12px' },
};

export default UploadMarks;